<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="Argon"
      title="Argon"
    >
      <template slot="links">
        <!-- <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard'
          }"
        /> -->
        <sidebar-item :link="{name: 'Leagues', icon: 'ni ni-trophy text-info', path: '/leagues'}"/>
        <sidebar-item :link="{name: 'Players', icon: 'ni ni-single-02 text-orange', path: '/players'}"/>
        <sidebar-item :link="{name: 'Live Games', icon: 'fa fa-tv text-success', path: '/live'}"/>
        <!-- <sidebar-item :link="{name: 'Courses', icon: 'ni ni-square-pin text-red', path: '/courses'}"/>
        <sidebar-item :link="{name: 'Settings', icon: 'ni ni-settings text-blue', path: '/settings'}"/> -->

      </template>
      <template slot="">

      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
import { FadeTransition } from 'vue2-transitions';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      sidebarBackground: 'vue', // vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
};
</script>
<style lang="scss">
</style>
